import React from 'react';
import { Route, Redirect } from 'react-router-dom';
var jwtDecode = require('jwt-decode');

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      validateJWT(localStorage.getItem('user')) ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/auth', state: { from: props.location } }} />
      )
    }
  />
);

function validateJWT(token) {
  if (!token) {
    return false;
  }
  var decoded = jwtDecode(token);
  var current_time = new Date().getTime() / 1000;
  if (current_time < decoded.exp) {
    return true;
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/_components/PrivateRoute.jsx